import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'
import { useEffect, useState } from 'react'

const NjInformationForm = ({ navigation, route }) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params
    const { loading, getmodetails, postnjonline } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()
    const intialValues = {
        filingstatus: "",
        wageChartLetter: "",
        totalAllowances: "",
        additionalamount: "",
        claimExemption: ""
    }

    const options1 = [
        {
            key: 1,
            value: 'Single or Married Filing Separately'
        },
        { key: 2, value: 'Married/Civil Union Couple Joint' },
        { key: 3, value: 'Married/Civil Union Partner Separate' },
        { key: 4, value: 'Head of Household' },
        { key: 5, value: 'Qualifying Widow(er)/Surviving Civil Union Partner' },

    ]

    const options2 = [
        {
            key: 1,
            value: 'A'
        },
        { key: 2, value: 'B' },
        { key: 3, value: 'C' },
        { key: 4, value: 'D' },
        { key: 5, value: 'E' },

    ]
    const paschema = yup.object({
        filingstatus: yup
            .string()
            .required('Filing status is a required field'),
        wageChartLetter: yup
            .string()
            .nullable(),
        totalAllowances: yup
            .string()
            .required('Total no of allowances is a required field'),
        additionalamount: yup.string().nullable(),
        claimExemption: yup.string().matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
    })
    // useEffect(() => {
    //     getmodetails(initializestore?.initializeData?.userkey)
    // }, [])


    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'NJ Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={paschema}
                    onSubmit={async (values, actions) => {

                        const data = {
                            entityId: personalstore.personalData?.entityId,
                            essUserKey:
                                initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey:
                                essUserOnBoardingFormKey,
                            completeOnline: mode == "online" ? true : false,
                            filingStatus: values?.filingstatus,
                            wageChartLetter: values?.wageChartLetter,
                            totalAllowances: values?.totalAllowances,
                            additionalAmount: values?.additionalamount ? values?.additionalamount : null,
                            claimExemption: values?.claimExemption ? values?.claimExemption?.toUpperCase() : ""
                        }
                        const response = await postnjonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('NjInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,

                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => (
                        <Card>
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '65%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {'Filing Status *'}
                                    </Text>
                                </View>
                                <View style={{ width: '30%', overflow: 'hidden' }}>
                                    <SelectKeyValue
                                        title="Filing Status"
                                        options={options1}
                                        selectedOption={mapSelectValue(
                                            options1,
                                            props.values.filingstatus
                                        )}
                                        onSelect={(option: any) => {
                                            props.setFieldValue('filingstatus', option - 1)
                                        }}
                                        textColor="primary"
                                    />
                                    {props.touched.filingstatus &&
                                        props.errors.filingstatus && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.filingstatus}
                                            </Text>
                                        )}
                                </View>
                            </View>


                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ width: '65%', justifyContent: 'center' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'If you have chosen to use the chart from instruction A, select the appropriate letter here'
                                        }
                                    </Text>
                                </View>

                                <View style={{ width: '30%', overflow: 'hidden' }}>
                                    <SelectKeyValue
                                        title="If you have chosen to use the chart from instruction A, select the appropriate letter here"
                                        options={options2}
                                        selectedOption={props.values.wageChartLetter}
                                        onSelect={(option: any) => {
                                            const selectedOption = options2.find(item => item.key === option);
                                            props.setFieldValue('wageChartLetter', selectedOption?.value);
                                        }}
                                        textColor="primary"
                                    />
                                    {props.touched.wageChartLetter &&
                                        props.errors.wageChartLetter && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.wageChartLetter}
                                            </Text>
                                        )}
                                </View>
                            </View>
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ width: '65%', justifyContent: 'center' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {'Total number of allowances you are claiming *'}
                                    </Text>
                                </View>
                                <View style={{ width: '30%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.totalAllowances}
                                        onChangeText={(text) => {
                                            if (text === '' || /^\d+$/.test(text)) {
                                                props.handleChange('totalAllowances')(text)
                                            }
                                        }}
                                        keyboardType="numeric"
                                    />
                                    {props.touched.totalAllowances &&
                                        props.errors.totalAllowances && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.totalAllowances}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            {props.values.claimExemption?.toLowerCase() !== 'exempt' && (
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Additional amount you want deducted from each pay'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.additionalamount}
                                            keyboardType='numeric'
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('additionalamount')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.additionalamount &&
                                            props.errors.additionalamount && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.additionalamount}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                            )}


                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ width: '65%', justifyContent: 'center' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {'I claim exemption from withholding of NJ Gross Income Tax and I certify that I have met the conditions in the instructions of the NJ-W4. If you have met the conditions, enter “EXEMPT” here'}
                                    </Text>
                                </View>
                                <View style={{ width: '30%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.claimExemption}
                                        onChangeText={(text) => {
                                            props.handleChange('claimExemption')(text)
                                            if (text?.toLowerCase() === 'exempt') {
                                                props.setFieldValue('additionalamount', '')
                                            }
                                        }}
                                    />
                                    {props.touched.claimExemption &&
                                        props.errors.claimExemption && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.claimExemption}
                                            </Text>
                                        )}
                                </View>
                            </View>




                            {loading ? (
                                <ActivityIndicator />
                            ) : (
                                <View style={{ margin: 10 }}>
                                    <CustomButton
                                        text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                        onPress={props.handleSubmit}
                                    />
                                </View>
                            )}
                        </Card>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default NjInformationForm
